export default __webpack_public_path__ + "locales/bg/Settings.json?hash=171c2ce3f806215c37910613b037ac4c";